module.exports = __webpack_public_path__ + "img/home_anli.d3a736b3.jpg";